module.exports = __webpack_public_path__ + "static/img/bnet-default-cn.7a2e505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bnet-default-cn.png
// module id = 52AP
// module chunks = 0